import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "home-container"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_ctx.eventData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24,
              class: "app__header__title"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("program.events")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24,
              class: "app__title"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("drawer.expo")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24,
              class: "text-center mt-1 mb-2"
            }, {
              default: _withCtx(() => [
                (_ctx.eventData.expoImage)
                  ? (_openBlock(), _createBlock(_component_el_image, {
                      key: 0,
                      src: _ctx.eventData.expoImage
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("expo.notFound")), 1),
                      _createVNode(_component_el_button, {
                        class: "secondary__color__button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'Home' })))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("notFound.goHomeBtn")), 1)
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}